import React, { useState } from 'react';

import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { generateUUID } from 'utils/Helpers/UUID';

import { AddSmartEventActionModal, SmartEventActionsTable } from '.';

interface IActionsStepProps {
  actions: ISmartEventActionForm[];
  conditions: ISmartEventConditionForm[];
  setActions: any;
}

const ActionsStep = ({ actions, conditions, setActions }: IActionsStepProps) => {
  const intl = useIntl();
  const [addAction, setAddAction] = useState(false);

  const handleAddAction = (values: ISmartEventActionForm | null) => {
    if (values) {
      setActions([...actions, { id: generateUUID(), ...values }]);
    }
    setAddAction(false);
  };

  return (
    <>
      <h5 className=" m-0 mt-4">{intl.formatMessage({ id: 'actionsKey' })}</h5>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <p className="m-0">{intl.formatMessage({ id: 'minimumActionKey' })}</p>
        <Button
          variant="link"
          className="m-0"
          onClick={() => setAddAction(true)}
          data-test="smart-event-add-action"
        >
          + {intl.formatMessage({ id: 'actionKey' })}
        </Button>
      </div>
      <SmartEventActionsTable actions={actions} setActions={setActions} />
      <AddSmartEventActionModal show={addAction} conditions={conditions} close={handleAddAction} />
    </>
  );
};

export default ActionsStep;
